__turbopack_context__.v({
  "burgerContainer": "FusionHeaderBurger-module-scss-module__VrYR0q__burgerContainer",
});
